import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingLeft: 25,
  },
  content: {
    padding: 0,
    marginTop: 1,
  },
  pageTitle: {
    textTransform: "uppercase",
    paddingVertical: 15,
    fontSize: 14,
    color: "#2C2C2E",
    fontWeight: "bold",
    textAlign: 'center',
  },
  header: {
    flex: 1,
    paddingHorizontal: 30,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  header_action_container: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  header_text: {
    marginRight: 10,
    color: "#2C2C2E",
  },
  assets_list: {
    flex: 1,
    padding: 5,
    flexDirection: "row",
    flexWrap: "wrap",
  },
  asset: {
    flexDirection: 'column',
    padding: 10,
    margin: 5,
    height: 100,
    width: 100,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFF",
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderWidth: 1,
    borderColor: "#c1c1c1"
  },
  category: {
    flexDirection: 'column',
    marginHorizontal: 10,
    marginTop: 20,
    justifyContent: "center",
    backgroundColor: "#FFF",
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderWidth: 1,
    borderColor: "#c1c1c1",
    overflow: "hidden"
  },
  categoryTitle: {
    fontWeight: "bold"
  },
  categoryHeader: {
    flex: 1,
    width: "100%",
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 15,
    backgroundColor: '#E6E6E6'
  },
  categoryBody: {
    padding: 15
  },
  asset_name: {
    textTransform: "uppercase",
    fontSize: 12,
    color: "#2C2C2E",
    fontWeight: "bold",
    textAlign: 'center',
    overflow: "hidden",
    flexWrap: "nowrap",
    flexShrink: 1
  },
  asset_icon: {
    width: 50,
    height: 50,
    borderRadius: 50
  },
  tabContent: {
    flexDirection: 'row',
    flexWrap: "wrap",
    justifyContent: 'space-between'
  },
  tokens_list: {
    position: "absolute",
    bottom: 0,
    width: "90%",
    height: "42%",
    alignItems: "center",
    backgroundColor: "#fff",
    borderTopLeftRadius: 35,
    borderTopRightRadius: 35,
  },
  tokens_display_action: {
    alignItems: "center",
    paddingVertical: 10,
  },
  token: {
    flex: 1,
    padding: 10,
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 20,
    alignItems: "center",
    flexDirection: "row",
    borderColor: "#F4F4F4",
    justifyContent: "space-between",
  },
  scroll_view: {
    flex: 1,
    width: "100%",
    height: "30%",
    padding: 20,
    position: "absolute",
    top: "25%",
    height: "50%",
  },
  sectionHeader: {
    fontSize: 16,
    backgroundColor: "#333",
    color: "#fff",
    fontWeight: "bold",
    padding: 15
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: 16,
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#666"
  },
  title: {
    fontSize: 16
  }
});

export default styles;
